(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.controller
  (:require
   [frontend.ui.component.lp-portal.report.overview.big-figures.controller :as big-figures]
   [frontend.ui.component.lp-portal.report.overview.historical-net-cash-flows-chart.controller
    :refer [historical-net-cash-flows]]
   [frontend.ui.component.lp-portal.report.overview.portfolio-at-fair-value.controller
    :refer [portfolio-at-fair-value]]
   [frontend.ui.component.lp-portal.report.overview.total-investment-chart.controller
    :refer [total-investment]]
   [frontend.ui.component.lp-portal.report.tearsheet.largest-investments-at-fair-value.controller
    :refer [largest-investments-at-fair-value]]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-by-country-at-fair-value.controller
    :refer [portfolio-by-country-at-fair-value]]
   [frontend.ui.component.lp-portal.report.tearsheet.return-development.controller
    :refer
    [tvpi]]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.page.lp-portal.report.util :as report-utils]))

(defn tearsheet-ui-data
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  {:tvpi (report-ctl/with-footnote
          props
          :tvpi-footnote
          (tvpi (get-in report-data [:tearsheet :tvpi])
                {}))
   :return-development (report-ctl/with-footnote
                        props
                        :return-development-footnotes
                        (get-in report-data [:tearsheet :return-development]))
   :largest-investments-at-fair-value (report-ctl/with-footnote
                                       props
                                       :largest-investments-footnotes
                                       (largest-investments-at-fair-value
                                        (get-in report-data
                                                [:tearsheet :largest-investments-at-fair-value])))
   :portfolio-by-country-at-fair-value (report-ctl/with-footnote
                                        props
                                        :portfolio-by-country-footnotes
                                        (portfolio-by-country-at-fair-value
                                         (get-in report-data
                                                 [:tearsheet :portfolio-by-country-at-fair-value])))
   :basic-information-primary (report-ctl/with-footnote
                               props
                               :basic-information-primary-footnotes
                               (get-in report-data
                                       [:basic-information-primary]))
   :basic-information-secondary (report-ctl/with-footnote
                                 props
                                 :basic-information-secondary-footnotes
                                 (get-in report-data [:basic-information-secondary]))})

(defn overview-ui-data
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  {:overview-figures          (report-ctl/with-footnote props
                                                        :overview-figures-footnotes
                                                        (big-figures/summary-figures report-data))
   :recent-development-text   (report-ctl/rich-content props
                                                       :recent-development-text)
   :recent-development        (report-ctl/with-footnote props
                                                        :recent-development-footnotes
                                                        (:fund-figures report-data))
   :total-investment          (report-ctl/with-footnote props
                                                        :total-investment-footnotes
                                                        (total-investment (get-in report-data
                                                                                  [:chart-data
                                                                                   :at-cost])))
   :portfolio-at-fair-value   (report-ctl/with-footnote props
                                                        :portfolio-at-fair-value-footnotes
                                                        (portfolio-at-fair-value
                                                         (get-in report-data
                                                                 [:chart-data :fair-value])))
   :historical-net-cash-flows (report-ctl/with-footnote props
                                                        :historical-net-cashflows-footnotes
                                                        (historical-net-cash-flows
                                                         (get-in report-data
                                                                 [:chart-data :table])))})

(defn details-and-figures-ui-data
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  {:current-portfolio     (report-ctl/with-footnote props
                                                    :current-portfolio-footnotes
                                                    (get-in
                                                     report-data
                                                     [:current-portfolio]))
   :exited-portfolio      (report-ctl/with-footnote props
                                                    :exited-portfolio-footnotes
                                                    (get-in report-data
                                                            [:exited-portfolio]))
   :investment-summary    (report-ctl/with-footnote props
                                                    :investment-summary-footnotes
                                                    (:investment-summary report-data))
   :cash-flows-and-assets (report-ctl/with-footnote props
                                                    :cash-flows-and-assets-footnotes
                                                    (get-in report-data
                                                            [:cash-flows-and-assets]))})

(defn raw-data->editable-data
  [raw-data]
  (let [columns (if (nil? (:column-order raw-data))
                  (:columns raw-data)
                  (:column-order raw-data))]
    {:columns (vec columns)
     :data    (if (map? (:data raw-data)) ;;Old data model
                (->> raw-data
                     :data
                     (mapv (fn [[row-label row-data]]
                             (vec (cons row-label
                                        (->> columns
                                             (mapv (fn [k]
                                                     (get row-data k)))))))))
                (:data raw-data))}))

(defn editable-data->raw-data
  [editable-data]
  (let [columns (->> editable-data
                     :columns)
        data-rows (->> editable-data
                       :data
                       (mapv
                        (fn [row]
                          (let [row-vals (map (partial report-utils/blank-value->empty-indicator-str "-") (rest row))]
                            (vec (cons (first row) row-vals))))))]
    {:column-order columns
     :data data-rows}))

(defn esg-ui-data
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  (let [{:keys [esg]} report-data]
    {:esg-targets-and-strategy-text (report-ctl/rich-content props
                                                             :esg-targets-and-strategy-text)
     :key-perf-indicators (->> (report-ctl/with-footnote props
                                                         :key-perf-indicators-footnotes
                                                         esg)
                               (report-ctl/with-editable-tables props :key-perf-indicators
                                                                raw-data->editable-data
                                                                editable-data->raw-data))
     :gresb (get-in report-data [:esg :gresb])
     :incidents-text (report-ctl/rich-content props :incidents-text)}))

(defn investors-ui-data
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  (report-ctl/with-footnote props
                            :investors-footnotes
                            (:investors report-data)))
